<template>
    <v-container>
            <v-layout>
                <v-flex>
                    <div>
                        <v-layout>
                            <v-flex xs12 sm6 offset-sm6>
                                <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Buscar"
                                        single-line
                                        hide-details
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-flex>
                <v-dialog
                        v-model="dialog"
                        transition="dialog-bottom-transition"
                        fullscreen
                        scrollable>
                    <v-card tile>
                        <v-toolbar card dark color="nav_background_color">
                            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                                <v-icon>close</v-icon>
                            </v-btn>
                            <v-toolbar-title>{{reportType=='RUTA'?"Reporte de Ruta":"Reporte de Kilometraje"}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <v-form ref="formDevice" v-model="valid" lazy-validation>
                              <div v-if="reportType=='RUTA'" class="column" style="width: 25%;float: left;">
                                <div>
                                  <v-layout>
                                    <v-flex xs12 sm8 offset-sm1>
                                      <h4>Dispositivo: {{device.name}}</h4>
                                    </v-flex>
                                  </v-layout>
                                  <br>
                                  <v-layout>
                                    <v-flex xs12 sm5 offset-sm1>
                                      <v-menu
                                          ref="menu"
                                          :close-on-content-click="false"
                                          v-model="menu"
                                          :nudge-right="40"
                                          :return-value.sync="date"
                                          lazy
                                          transition="scale-transition"
                                          offset-y
                                          full-width
                                          min-width="290px">
                                        <v-text-field
                                            slot="activator"
                                            v-model="device.start"
                                            label="Fecha inicio"
                                            prepend-icon="event"
                                            readonly
                                            :rules="[v => !!v || 'La fecha de inicio es requerida']"
                                            required
                                        ></v-text-field>
                                        <v-date-picker v-model="device.start"
                                                       @input="$refs.menu.save(device.start)"></v-date-picker>
                                      </v-menu>
                                    </v-flex>
                                    <v-flex xs12 sm3>
                                      <vue-timepicker v-if="device!=''" v-model="device.startTime" format="HH:mm"
                                                      :rules="[v => !!v || 'La hora de inicio es requerida']"
                                                      required
                                      ></vue-timepicker>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs12 sm5 offset-sm1>
                                      <v-menu
                                          ref="menu2"
                                          :close-on-content-click="false"
                                          v-model="menu2"
                                          :nudge-right="40"
                                          :return-value.sync="date"
                                          lazy
                                          transition="scale-transition"
                                          offset-y
                                          full-width
                                          min-width="290px">
                                        <v-text-field
                                            slot="activator"
                                            v-model="device.end"
                                            label="Fecha fin"
                                            prepend-icon="event"
                                            readonly
                                            :rules="[v => !!v || 'La fecha de fin es requerida']"
                                            required
                                        ></v-text-field>
                                        <v-date-picker v-model="device.end"
                                                       @input="$refs.menu2.save(device.end)"></v-date-picker>
                                      </v-menu>
                                    </v-flex>
                                    <v-flex xs12 sm3>
                                      <vue-timepicker v-if="device!=''" v-model="device.endTime" format="HH:mm"
                                                      :rules="[v => !!v || 'La hora de fin es requerida']"
                                                      required
                                      ></vue-timepicker>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs12 sm6 offset-sm1>
                                      <v-btn class="btn-rounded" :disabled="!valid"
                                             @click="searchData()" large color="primary">Buscar
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                  <br>
                                  <v-layout> 
                                    <v-flex >
                                      <div>
                                        <v-btn class="btn-rounded"
                                              @click="searchData('TODAY')" large color="primary">Reporte de hoy
                                        </v-btn>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex >
                                      <div>
                                        <v-btn class="btn-rounded"
                                               @click="searchData('YESTERDAY')" large color="primary">Reporte de ayer
                                        </v-btn>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </div>
                                <br>
                                <v-divider v-if="reportType=='RUTA' && this.listReportTracking.length>0"></v-divider>
                                <br>
                                <v-flex xs12 sm12 offset-sm1>
                                  <div v-if="reportType=='RUTA' && this.listReportTracking.length>0 && this.listReportTracking[this.increment]">
                                    <span style="font-weight: bold">Hora:</span><span>  {{this.formatDateMinus(this.listReportTracking [this.increment].gpsTime)}}</span>
                                    <br>
                                    <span style="font-weight: bold">Velocidad:</span><span>  {{(this.listReportTracking [this.increment].speed*1.852).toFixed(2)}} KM/H</span>
                                    <br>
                                    <span style="font-weight: bold">Total Recorrido:</span><span>  {{ (this.distance/1000).toFixed(2)}} KM</span>
                                    <br>
                                    <span style="font-weight: bold;">Inicio Recorrido:</span><span>  {{this.formatDateMinus(this.listReportTracking[0].gpsTime)}}</span>
                                    <br>
                                    <span style="font-weight: bold;"> Fin Recorrido:</span><span> {{this.formatDateMinus(this.listReportTracking[this.listReportTracking.length-1].gpsTime)}}</span>
                                    <br>
                                    <span style="font-weight: bold;"> Dirección inicio:</span><span> {{this.directionStart}}</span>
                                    <br>
                                    <span style="font-weight: bold;"> Dirección fin:</span><span> {{this.directionEnd}}</span>
                                  </div>
                                </v-flex>
                                <v-layout v-if="reportType=='RUTA' && this.listReportTracking.length>0">
                                  <v-flex xs12 sm8 offset-sm1>
                                    <v-slider
                                        v-model="increment"
                                        :max="listReportTracking.length"
                                        :min="0"
                                        :step="1"
                                        style="margin-left: 10px; margin-right: 5px"
                                        @change="playTrack"
                                    ></v-slider>
                                    <div align="center">
                                      <v-btn
                                          v-if="buttonTrack=='PLAY'"
                                          fab dark
                                          small @click="createInterval"
                                          slot="activator"
                                          color="primary">
                                        <v-icon dark>play_arrow</v-icon>
                                      </v-btn>
                                      <v-btn
                                          v-if="buttonTrack=='PAUSE'"
                                          fab dark
                                          small @click="pauseInterval"
                                          slot="activator"
                                          color="primary">
                                        <v-icon dark>pause</v-icon>
                                      </v-btn>
                                      <v-btn
                                          fab dark
                                          small @click="stopInterval"
                                          slot="activator"
                                          color="primary">
                                        <v-icon dark>stop</v-icon>
                                      </v-btn>

                                      <v-btn
                                          fab dark
                                          small @click="changeInterval"
                                          slot="activator"
                                          color="primary">
                                        <v-icon dark>fast_forward</v-icon>
                                      </v-btn>
                                      <span style="font-size: 13px">{{this.timeIntervalDescription}}</span>
                                    </div>

                                  </v-flex>
                                </v-layout>
                                <br>
                                <v-divider v-if="reportType=='RUTA' && this.listReportTracking.length>0"></v-divider>
                                <br>
                                <div v-if="reportType=='RUTA' && this.listReportTracking.length>0">
                                  <v-layout>
                                    <v-flex xs12 sm8 offset-sm1>
                                      <download-excel :fetch="getReport"
                                                      style="width:200px"
                                                      name="reporte_ubicación.xls">
                                        <v-btn small color="primary">
                                          Reporte de ubicación
                                          <v-icon right dark>cloud_download</v-icon>
                                        </v-btn>
                                      </download-excel>
                                      <download-excel :fetch="getReportStops"
                                                      style="width:200px"
                                                      name="reporte_paradas.xls">
                                        <v-btn small color="primary">
                                          Reporte de paradas
                                          <v-icon right dark>cloud_download</v-icon>
                                        </v-btn>
                                      </download-excel>

                                    </v-flex>
                                  </v-layout>
                                </div>
                              </div>
                              <div class="column" style="width: 75%;height: 100%; float: left">

                                <GmapMap ref="gmap"
                                         :center="this.mapView"
                                         :zoom="14"
                                         map-type-id="roadmap"
                                         :options="{
                                    scaleControl: true,
                                    mapTypeControl: true,
                                    zoomControl: true,
                                    scrollwheel: true,
                                    keyboardShortcuts: false,
                                    gestureHandling: 'greedy'
                                  }"
                                         style="width: 100%; height:92vh;"
                                >
                                  <GmapMarker
                                      :key="index"
                                      v-for="(m, index) in markers"
                                      :position="m.position"
                                      :clickable="true"
                                      :icon="m.icon"
                                      id="img"
                                  />
                                  <GmapMarker
                                      :key="m.id"
                                      v-for="(m) in markerStops"
                                      :position="m.position"
                                      :clickable="true"
                                      @click="selectMarker(m)"
                                      :icon="m.icon"
                                      id="img2"
                                  />
                                    <GmapMarker
                                    :key="m.id"
                                    v-for="(m) in markerStart"
                                    :position="m.position"
                                    :clickable="true"
                                    @click="selectMarker(m)"
                                    :icon="customIconGreen"
                                   />

                                   <GmapMarker
                                   :key="m.id"
                                   v-for="(m) in markerEnd"
                                   :position="m.position"
                                   :clickable="true"
                                   @click="selectMarker(m)"
                                   :icon="customIconRed"
                                  />

                                  <gmap-polyline :key="m.id"
                                                 v-for="(m) in path"
                                                 :path="m.position"
                                                 @click="selectPolyline(m)"
                                                 :options="{ strokeColor:m.colorLine}"
                                  />
                                  <gmap-info-window v-if="markerStop"
                                      @closeclick="windowOpen=false"
                                      :opened="windowOpen"
                                      :position="markerStop.position"
                                      :options="{
                                      pixelOffset: {
                                        width: 0,
                                        height: -35
                                      }
                                    }"
                                  >
                                    <button @click="windowOpen=false" style="float: right; font-size: 24px;"><strong>X</strong></button>
                                    <p><strong>Datos de dispositivo</strong></p>
                                    <p v-if="markerStop.data.startTime"><strong>Inicio:</strong> {{formatDateMinus(markerStop.data.startTime)}}</p>
                                    <p v-if="markerStop.data.endTime"><strong>Fin:</strong> {{formatDateMinus(markerStop.data.endTime)}}</p>
                                    <p v-if="markerStop.data.duration"><strong>Tiempo:</strong> {{$store.getters.msToTime(markerStop.data.duration)}}</p>
                                    <p><strong>Latitud:</strong> {{Number(markerStop.data.latitude.toFixed(5))}}</p>
                                    <p><strong>Longitud:</strong> {{Number(markerStop.data.longitude.toFixed(5))}}</p>
                                    <p><strong>Dirección:</strong> {{this.direction}}</p>
                                  </gmap-info-window>

                                  <gmap-info-window v-if="markerSpeed"
                                                    @closeclick="windowOpen=false"
                                                    :opened="windowOpen"
                                                    :position="markerSpeed.position"
                                                    :options="{
                                      pixelOffset: {
                                        width: 0,
                                        height: -35
                                      }
                                    }"
                                  >
                                    <p><strong>Velocidad</strong></p>
                                    <p>{{markerSpeed.speed.toFixed(2)}} KM/H</p>
                                  </gmap-info-window>
                                </GmapMap>
                              </div>
                            </v-form>
                        </v-card-text>
                        <div style="flex: 1 1 auto;"></div>
                    </v-card>
                </v-dialog>
            </v-layout>
            <v-data-table
                    :headers="headers"
                    :items="this.devices"
                    :search="search"
                    class="elevation-1"
                    sort-icon="mdi-menu-down"
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left">
                        <v-checkbox
                                :value="props.item.selected"
                                color="blue"
                                @change="selectedItem(props.item)"
                                hide-details
                        ></v-checkbox>
                    </td>
                    <td class="text-xs-left">
                        <div align="center"><img :src="props.item.image" width="40px"></div></td>
                    <td class="text-xs-left">{{ props.item.userName }}</td>
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">{{ props.item.imei }}</td>
                    <td class="text-xs-left">{{ props.item.sim }}</td>
                    <td class="text-xs-left">{{ props.item.model }}</td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    No se han encontrado resultados para "{{ search }}".
                </v-alert>
            </v-data-table>
      <v-btn class="btn-rounded" :disabled="!singleSelect"  large color="primary" @click="dialog = true;">Ver Reporte</v-btn>
      <v-dialog
                v-model="dialogBlock"
                max-width="500px">
            <v-card tile>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout>
                            <h2>¿Seguro quieres
                                bloquear/abrir seguros
                                de {{this.editedIndex!=-1?this.devices[this.editedIndex].name:""}}?</h2>
                        </v-layout>
                        <v-layout>
                            <v-flex class="text-xs-center">
                                <div>
                                    <v-btn class="btn-rounded" :disabled="!valid"
                                           @click="sendDeviceAction()" large color="primary">Bloquear / Desbloquear
                                    </v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
        <v-dialog v-if="dialogIcon==true"
                  v-model="dialogIcon"
                  max-width="700px">
            <v-card tile>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout>
                            <v-data-table
                                    :headers="headersCars"
                                    :items="cars"
                                    :search="search"
                                    class="elevation-1"
                                    sort-icon="mdi-menu-down"
                                    hide-actions
                                    hide-details
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <div align="center"><img :src="props.item.icon1" @click="device.image=props.item.icon1; dialogIcon=false" width="70px" height="70px"></div>
                                    </td>
                                    <td class="text-xs-left">
                                        <div align="center"><img :src="props.item.icon2" @click="device.image=props.item.icon2; dialogIcon=false" width="70px" height="70px"></div>
                                    </td>
                                    <td class="text-xs-left">
                                        <div align="center"><img :src="props.item.icon3" @click="device.image=props.item.icon3; dialogIcon=false" width="70px" height="70px"></div>
                                    </td>
                                    <td class="text-xs-left">
                                        <div align="center"><img :src="props.item.icon4" @click="device.image=props.item.icon4; dialogIcon=false" width="70px" height="70px"></div>
                                    </td>
                                    <td class="text-xs-left">
                                        <div align="center"><img :src="props.item.icon5" @click="device.image=props.item.icon5; dialogIcon=false" width="70px" height="70px"></div>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-layout>
                        <v-layout>
                            <v-flex class="text-xs-center">
                                <div>
                                    <v-btn class="btn-rounded" :disabled="!valid" @click="dialogIcon=false" large color="primary">Guardar</v-btn>
                                    <v-btn class="btn-rounded" :disabled="!valid" @click="dialogIcon=false" large color="primary">Cerrar</v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>
    import Device from '../../model/Device';
    import DeviceMap from '../device/DeviceMap';
    import GeoFence from '../device/GeoFence';
    import VueTimepicker from 'vue2-timepicker/src'
    import $ from "jquery";
    const uuid = require('uuid');



    export default {
        components: {
            DeviceMap,
            GeoFence,
          VueTimepicker
        },
        watch: {
          markers(){
            const self= this
            setTimeout(function(){
              $('img[src*="'+self.imageDevice+'"]').parent().css('transform', 'rotate(' + self.listReportTracking [self.increment].direction + 'deg)');
            }, 5);
          }
        },
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                dialogIcon: false,
                windowOpen: false,
                tab:"",
                customIconGreen: {
                  url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png', // URL to your custom icon
                  scaledSize: new google.maps.Size(48, 48), // size of the icon
                },
                customIconRed: {
                  url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png', // URL to your custom icon
                  scaledSize: new google.maps.Size(48, 48), // size of the icon
                },
                cars:[
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/001-ambulance1.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/002-armored+vehicle.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/003-bus.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/004-four+wheel+drive.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/005-car.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/006-cement+truck.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/007-excavator.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/008-f1.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/009-fire+truck.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/010-fire+truck.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/011-food+truck.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/012-food+truck.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/013-go+kart.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/014-golf+cart.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/015-jeep.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/016-limousine.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/017-motorcycle.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/018-pickup+truck.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/019-police+car.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/020-racing.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/021-racing.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/022-sport+car.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/023-sport+car.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/024-scooter.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/025-tank.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/026-tank.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/027-taxi.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/028-tow+truck.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/029-truck.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/030-Tuk+tuk.png"},

                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/001-ambulance.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/002-hot-air-balloon.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/003-bicycle.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/004-aeroplane.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/005-boat.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/006-bus-school.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/007-cable-car.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/008-camper.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/009-car.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/010-cargo.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/011-cement.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/012-delivery-truck.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/013-electric-car.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/014-ferry.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/015-forklift.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/016-garbage-truck.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/016-garbage-truck.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/018-sea-scooter.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/019-motorbike.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/020-paragliding.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/021-plane.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/022-rocket.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/023-ship.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/024-railway.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/025-spaceship.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/026-safari.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/027-tanker-truck.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/028-taxi.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/029-trailer.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/030-train.png"},
                    {icon1:"https://avatars-tupgps.s3.amazonaws.com/031-tram.png",icon2:"https://avatars-tupgps.s3.amazonaws.com/032-truck.png",icon3:"https://avatars-tupgps.s3.amazonaws.com/033-tv.png",icon4:"https://avatars-tupgps.s3.amazonaws.com/034-van.png",icon5:"https://avatars-tupgps.s3.amazonaws.com/036-zeppelin.png"},
                ],
                headers: [
                    {text: '', value: ''},
                    {text: 'Avatar', value: 'avatar'},
                    {text: 'Cuenta', value: 'userName'},
                    {text: 'Nombre del equipo', value: 'name'},
                    {text: 'IMEI', value: 'imei'},
                    {text: 'SIM', value: 'sim'},
                    {text: 'Modelo', value: 'model'},
                ],
                headersCars: [
                    {text: '', value: ''},
                    {text: '', value: ''},
                    {text: '', value: ''},
                    {text: '', value: ''},
                    {text: '', value: ''}
                ],

                headersReport: [
                  {text: 'Hora Inicio', value: 'startTime'},
                  {text: 'Hora Fin', value: 'endTime'},
                  {text: 'Distancia', value: 'distance'},
                  {text: 'Velocidad Promedio', value: 'avgSpeed'},
                  // {text: 'Kilómetros al Inicio', value: 'startMileage'},
                  // {text: 'Kilómetros al Final', value: 'endMileage'},
                  // {text: 'Total Kilómetros', value: 'totalMileage'},
                  {text: 'Punto de partida', value: 'start'},
                  {text: 'Punto de llegada', value: 'end'},
                ],
                markers: [],
                markerStops: [],
                markerStart: [],
                markerEnd: [],
                editedIndex: -1,
                device: new Device(),
                devices: [],
                date: "",
                menu: false,
                menu2: false,
                deviceObject: {id: "", value: "", date: new Date()},
                singleSelect: false,
                active: 0,
                dialogBlock: false,
                mapView:{lat:-0.190029, lng:-78.482114},
                reportType:'RUTA',
                interval : 0,
                path:[],
                reportData:[],
                increment: 1,
                listReportTracking:[],
                listStopsTracking:[],
                colorLine:'#008000',
                typesReport: ["RUTA", "KILOMETROS"],
                imageDevice: "",
                directionDevice: 0,
                buttonTrack: "PLAY",
                distance:0,
                timeInterval: 1500,
                timeIntervalDescription: "LENTO",
                markerStop: null,
                markerSpeed: null,
                direction:"",
                directionStart:"",
                directionEnd:""
            };
        },
        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.device = new Device();
                this.valid = false;
                this.dialog = false;
                this.singleSelect = false;
                this.device=""
                this.reportType=""
                this.listReportTracking=[]
                this.markerStop= null
                this.markerSpeed= null
                this.path=[]
                this.markers=[]
                this.reportType='RUTA'
                this.listStopsTracking=[]
                this.mapView={lat:-0.190029, lng:-78.482114}
                this.reload()
            },
            newDevice() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
                this.device = new Device();
            },
          searchData(dayToSearch){
              this.stopInterval()
              this.listReportTracking=[]
              this.increment=1
              this.interval= 0,
              this.reportData=[]
              this.path=[]
              this.listReportTracking=[]
              this.markerStops=[]
              this.markerStart=[]
              this.markerEnd=[]
              this.markerStop= null
              this.reportType='RUTA'
              this.listStopsTracking=[]
              this.mapView={lat:-0.190029, lng:-78.482114},
              this.$store.state.progress = false;
              let dateStart
              let dateEnd

              if(dayToSearch){
                if (dayToSearch === 'TODAY') {
                  let currentDate = new Date();
                  let year = currentDate.getFullYear();
                  let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                  let day = String(currentDate.getDate()).padStart(2, '0');

                  dateStart = `${year}-${month}-${day}T00:00:00Z`;
                  dateEnd = `${year}-${month}-${day}T23:59:59Z`;

              } else if (dayToSearch === 'YESTERDAY') {
                let currentDate = new Date();
                currentDate.setDate(currentDate.getDate() - 1); // Subtract 1 day for yesterday

                let year = currentDate.getFullYear();
                let month = String(currentDate.getMonth() + 1).padStart(2, '0');
                let day = String(currentDate.getDate()).padStart(2, '0');

                dateStart = `${year}-${month}-${day}T00:00:00Z`;
                dateEnd = `${year}-${month}-${day}T23:59:59Z`;

              } else if (dayToSearch === 'THIS WEEK') {
                  let currentDate = new Date();
                  let firstDayOfWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - currentDate.getDay());
                  let lastDayOfWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - currentDate.getDay() + 6);

                  let firstYear = firstDayOfWeek.getFullYear();
                  let firstMonth = String(firstDayOfWeek.getMonth() + 1).padStart(2, '0');
                  let firstDay = String(firstDayOfWeek.getDate()).padStart(2, '0');

                  let lastYear = lastDayOfWeek.getFullYear();
                  let lastMonth = String(lastDayOfWeek.getMonth() + 1).padStart(2, '0');
                  let lastDay = String(lastDayOfWeek.getDate()).padStart(2, '0');

                  dateStart = `${firstYear}-${firstMonth}-${firstDay}T00:00:00Z`;
                  dateEnd = `${lastYear}-${lastMonth}-${lastDay}T23:59:59Z`;

              } else if (dayToSearch === 'LAST WEEK OF LAST MONTH') {
                  let currentDate = new Date();
                  let lastDayOfPreviousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
                  let firstDayOfLastWeek = new Date(lastDayOfPreviousMonth.getFullYear(), lastDayOfPreviousMonth.getMonth(), lastDayOfPreviousMonth.getDate() - 6);
                  let lastDayOfLastWeek = new Date(lastDayOfPreviousMonth.getFullYear(), lastDayOfPreviousMonth.getMonth(), lastDayOfPreviousMonth.getDate());

                  let firstYear = firstDayOfLastWeek.getFullYear();
                  let firstMonth = String(firstDayOfLastWeek.getMonth() + 1).padStart(2, '0');
                  let firstDay = String(firstDayOfLastWeek.getDate()).padStart(2, '0');

                  let lastYear = lastDayOfLastWeek.getFullYear();
                  let lastMonth = String(lastDayOfLastWeek.getMonth() + 1).padStart(2, '0');
                  let lastDay = String(lastDayOfLastWeek.getDate()).padStart(2, '0');

                  dateStart = `${firstYear}-${firstMonth}-${firstDay}T00:00:00Z`;
                  dateEnd = `${lastYear}-${lastMonth}-${lastDay}T23:59:59Z`;

              }
            } else {
                  dateStart = this.device.start + "T" + this.device.startTime.HH + ":" + this.device.startTime.mm + ":00Z";
                  dateEnd = this.device.end + "T" + this.device.endTime.HH + ":" + this.device.endTime.mm + ":00Z";
              }
              let queryParam = "deviceId="+this.device.idTraccar+"&from="+dateStart+"&"+"to="+dateEnd
              this.$store.state.progress = true;
              this.$store.dispatch('getDevicesLocationTraccarReport', queryParam).then(response => {
                    if (response.data.result!=null && response.data.result.length > 0) {
                        this.searched = true
                        if (response.data.result != null && response.data.result.length > 0) {
                          this.listReportTracking = response.data.result
                          this.$store.dispatch('getDevicesLocationStopsTraccarReport', queryParam).then(response => {
                            this.listStopsTracking = response.data
                            for (const stop of this.listStopsTracking) {
                              let stopPosition = {
                                id: uuid.v4(),
                                position: {
                                  lat: stop.latitude,
                                  lng: stop.longitude,
                                },
                                icon: {
                                  url: 'https://imagenes-tugps.s3.amazonaws.com/stop1.png',
                                  scaledSize: {width: 30, height: 30, f: 'px', b: 'px'},
                                },
                                data: stop
                              }
                              this.markerStops.push(stopPosition)
                            }
                          })
                          this.$store.dispatch('getDevicesLocationTraccarAlarm', queryParam).then(response => {
                            let listEvents = response.data;
                            let lastIgnitionOffEvent = null;

                            // Sort events by eventTime before processing
                            const sortedEvents = listEvents.sort((a, b) => new Date(a.eventTime) - new Date(b.eventTime));

                            for (const event of sortedEvents) {
                              if (event.type === 'ignitionOff') {
                                // Track the ignitionOff event
                                lastIgnitionOffEvent = event;
                              } else if (event.type === 'ignitionOn' && lastIgnitionOffEvent) {
                                // Capture the current ignitionOff event in a local variable to preserve it
                                const ignitionOffEvent = lastIgnitionOffEvent;

                                // Ensure both events have valid `eventTime`
                                if (ignitionOffEvent.eventTime && event.eventTime) {
                                  const stopPositionId = ignitionOffEvent.positionId; // Use ignitionOff event's positionId

                                  // Fetch location for the ignitionOff position
                                  this.$store.dispatch('getDevicesLocationTraccarReport', "id=" + stopPositionId).then(responseLocation => {
                                    if (responseLocation.data.result[0]) {
                                      let positionStop = responseLocation.data.result[0];

                                      // Parse the event times and ensure time zones are handled
                                      const startTime = new Date(ignitionOffEvent.eventTime).getTime();
                                      const endTime = new Date(event.eventTime).getTime();

                                      // Ensure startTime is before endTime
                                      const correctStartTime = Math.min(startTime, endTime);
                                      const correctEndTime = Math.max(startTime, endTime);

                                      const duration = (correctEndTime - correctStartTime); // Duration in seconds

                                      // Create a marker for the stop with the necessary data
                                      let stopPosition = {
                                        id: uuid.v4(),
                                        position: {
                                          lat: positionStop.lat,
                                          lng: positionStop.lng,
                                        },
                                        icon: {
                                          url: 'https://imagenes-tugps.s3.amazonaws.com/stop1.png',
                                          scaledSize: { width: 30, height: 30 },
                                        },
                                        data: {
                                          startTime: new Date(correctStartTime).toISOString(),
                                          endTime: new Date(correctEndTime).toISOString(),
                                          duration: duration, // Store duration in seconds
                                          latitude: positionStop.lat,
                                          longitude: positionStop.lng
                                        }
                                      };

                                      this.markerStops.push(stopPosition);
                                    }
                                    // Reset lastIgnitionOffEvent after processing
                                    lastIgnitionOffEvent = null;
                                  });
                                } else {
                                  console.error('Missing eventTime for one of the events:', ignitionOffEvent, event);
                                }
                              }
                            }
                          });



                          this.reportData = response.data.result
                          let image = this.device.image
                          if(response.data.result[0].accStatus=='1' && parseInt(response.data.result[0].speed)>0){
                            image = image.replace("1.", "V.");
                          }else if(response.data.result[0].accStatus=='0'){
                            image = image.replace("1.", "R.");
                          }else if(response.data.result[0].accStatus=='1' && response.data.result[0].speed=='0'){
                            image = image.replace("1.", "A.");
                          }else{
                            image = image.replace("1.", "V.");
                          }
                          this.imageDevice = image
                          let respPosition = {
                            position: {
                              lat: this.listReportTracking [this.increment].lat,
                              lng: this.listReportTracking [this.increment].lng,
                            },
                            icon: {
                              url2: this.device.image,
                              url: image,
                              scaledSize: {width: 55, height: 55, f: 'px', b: 'px'},
                              rotation: [45]
                            },
                            markerOptions:{
                              zIndex:999999,
                              opacity:0.5,
                              rotation: 180
                            },
                          }
                          this.mapView = {
                            lat: this.listReportTracking [this.increment].lat,
                            lng: this.listReportTracking [this.increment].lng
                          }
                          this.markers.push(respPosition)
                          this.distance = 0
                          for (let i = 0; i <=this.listReportTracking.length ; i++) {
                            if(this.listReportTracking [i]!=null){
                              this.distance = this.distance + parseInt(this.listReportTracking [i].attributes.distance)
                            if ((this.listReportTracking [i].speed*1.852) > this.device.maxSpeed) {
                              this.colorLine = '#ff0000'
                            } else {
                              this.colorLine = '#008000'
                            }
                            this.mapView = {
                              lat: this.listReportTracking [i].lat,
                              lng: this.listReportTracking [i].lng
                            }
                            if(this.listReportTracking [i + 1]!=null){
                              this.path.push({
                                id: uuid.v4(),
                                position: [{
                                  lat: this.listReportTracking [i].lat,
                                  lng: this.listReportTracking [i].lng
                                }, {
                                  lat: this.listReportTracking [i + 1].lat,
                                  lng: this.listReportTracking [i + 1].lng
                                }], colorLine: this.colorLine, speed:this.listReportTracking [i].speed
                              })
                            }
                            if(i==0) {
                              this.markerStart.push({position: {
                                  lat: this.listReportTracking [i].lat,
                                  lng: this.listReportTracking [i].lng,
                                },
                                data:{latitude:this.listReportTracking [i].lat,longitude: this.listReportTracking [i].lng,}
                            })
                              this.$store.dispatch('getStreetFromCoordinates', {
                                lat: this.listReportTracking [i].lat,
                                lng: this.listReportTracking [i].lng,
                              }).then(response1 => {
                                this.directionStart = response1
                              })
                            }
                            if(i==this.listReportTracking.length-1){
                              this.markerEnd.push({position: {
                                  lat: this.listReportTracking [i].lat,
                                  lng: this.listReportTracking [i].lng,
                                },
                                data:{latitude:this.listReportTracking [i].lat,longitude: this.listReportTracking [i].lng,}
                            })
                              this.$store.dispatch('getStreetFromCoordinates', {
                                lat: this.listReportTracking [i].lat,
                                lng: this.listReportTracking [i].lng,
                              }).then(response1 => {
                                this.directionEnd = response1
                              })
                            }
                            }
                          }
                      }
                      this.$store.state.progress = false;
                    } else {
                      this.$store.state.progress = false;
                      this.$store.state.dialogError = true;
                      this.$store.state.dialogErrorHeader = "Información búsqueda"
                      this.$store.state.dialogErrorMessage = "No se han encontrado datos en la búsqueda realizada"
                    }
                  },
                  error => {
                    this.$store.state.progress = false;
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                  })
          },

          createInterval() {
            clearInterval(this.$store.state.intervalReport)
            this.$store.state.intervalReport = setInterval(() => {
              if (this.listReportTracking.length === this.increment) {
                clearInterval(this.$store.state.intervalReport)
              } else {
                this.increment = this.increment + 1;
                this.playTrack()
                this.buttonTrack = "PAUSE"
              }
            }, this.timeInterval);
          },
          stopInterval() {
            clearInterval(this.$store.state.intervalReport)
            this.increment = 1;
            this.buttonTrack = "PLAY"
            this.path = []
            this.markers = []
          },
          pauseInterval() {
            clearInterval(this.$store.state.intervalReport)
            this.buttonTrack = "PLAY"
          },
          changeInterval() {
            clearInterval(this.$store.state.intervalReport)
            if(this.timeInterval==1500){
              this.timeInterval = this.timeInterval - 1000
              this.timeIntervalDescription= "MEDIO"
            }else if(this.timeInterval==500){
              this.timeInterval = this.timeInterval - 200
              this.timeIntervalDescription= "RÁPIDO"
            }else if (this.timeInterval <= 300) {
              this.timeInterval = 1500
              this.timeIntervalDescription= "LENTO"
            }
            this.createInterval()
          },
          playTrack() {
            this.increment++;
            let image = this.device.image
            if(this.listReportTracking [this.increment+1].accStatus=='1' && parseInt(this.listReportTracking [this.increment+1].speed)>0){
              image = image.replace("1.", "V.");
            }else if(this.listReportTracking [this.increment+1].accStatus=='0'){
              image = image.replace("1.", "R.");
            }else if(this.listReportTracking [this.increment+1].accStatus=='1' && this.listReportTracking [this.increment+1].speed=='0'){
              image = image.replace("1.", "A.");
            }else{
              image = image.replace("1.", "V.");
            }
            this.imageDevice = image
            let respPosition = {
              position: {
                lat: this.listReportTracking [this.increment+1].lat,
                lng: this.listReportTracking [this.increment+1].lng,
              },
              icon: {
                url2: this.device.image,
                url: image,
                scaledSize: {width: 55, height: 55, f: 'px', b: 'px'},
                stylers: [{background: 'black', 'visibility': 'off'}]
              },
            }
            if(this.markers[0]==1){
              this.markers[0].position = respPosition
              this.markers[0].icon= {
                url2: this.device.image,
                url: image,
                scaledSize: {width: 55, height: 55, f: 'px', b: 'px'},
                stylers: [{background: 'black', 'visibility': 'off'}]
              }
            }else {
              this.markers = []
              this.markers.push(respPosition)
            }
            this.path=[]
            this.distance = 0
            for (let i = 0; i <=this.increment ; i++) {
              this.distance = this.distance + parseInt(this.listReportTracking[i].attributes.distance)

              if ((this.listReportTracking [i].speed*1.852) > this.device.maxSpeed) {
                this.colorLine = '#ff0000'
              } else {
                this.colorLine = '#008000'
              }
              this.mapView = {
                lat: this.listReportTracking [i].lat,
                lng: this.listReportTracking [i].lng
              }
              if(this.listReportTracking [i + 1]!=null){
                this.path.push({
                  position: [{
                    lat: this.listReportTracking [i].lat,
                    lng: this.listReportTracking [i].lng
                  }, {
                    lat: this.listReportTracking [i + 1].lat,
                    lng: this.listReportTracking [i + 1].lng
                  }], colorLine: this.colorLine, speed:this.listReportTracking [i].speed
                })
              }
            }
          },
          formatDate(dateString){
            let date = new Date(dateString);
            var day = date.getDate() + "";
            var month = (date.getMonth() + 1) + "";
            var year = date.getFullYear() + "";
            var hour = date.getHours();
            var minutes = date.getMinutes() + "";
            var seconds = date.getSeconds() + "";

            day = this.checkZero(day);
            month = this.checkZero(month);
            year = this.checkZero(year);
            hour = this.checkZero(hour);
            minutes = this.checkZero(minutes);
            seconds = this.checkZero(seconds);
            day = this.checkZero(day);
            month = this.checkZero(month);
            year = this.checkZero(year);
            hour = this.checkZero(hour);
            minutes = this.checkZero(minutes);
            seconds = this.checkZero(seconds);

            return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"Z";
          },

          formatDateMinus(dateString){
            let date = new Date(dateString);
            var day = date.getDate() + "";
            var month = (date.getMonth() + 1) + "";
            var year = date.getFullYear() + "";
            var hour = (date.getHours());
            var minutes = date.getMinutes() + "";
            var seconds = date.getSeconds() + "";

            day = this.checkZero(day);
            month = this.checkZero(month);
            year = this.checkZero(year);
            hour = this.checkZero(hour);
            minutes = this.checkZero(minutes);
            seconds = this.checkZero(seconds);

            return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"Z";
          },
          checkZero(data){
            if(data.toLocaleString().length == 1){
              data = "0" + data;
            }
            return data;
          },
          selectMarker(item) {
            this.markerStop = item
            this.$store.dispatch('getStreetFromCoordinates', {
              lat: this.markerStop.data.latitude,
              lng: this.markerStop.data.longitude,
            }).then(response1 => {
              this.direction = response1
              this.windowOpen = true
            })
          },

          selectPolyline(item) {
            this.markerSpeed= {position:{
                lat: item.position[0].lat,
                lng: item.position[0].lng
              }, speed:item.speed*1.852
            }
            this.windowOpen = true
          },
            saveData() {
                if (this.$refs.formDevice.validate()) {
                    this.deviceObject.value = JSON.stringify(this.device)
                    this.deviceObject.id = this.device.id
                    this.deviceObject.user = this.device.user
                    if (this.device.id != null && this.device.id != "") {
                        this.$store.dispatch('updateDevice', this.deviceObject).then(
                            response => {
                                this.reload();
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    } else {
                        this.deviceObject.date = new Date()
                        this.deviceObject.user = this.$store.state.deviceUser
                        this.deviceObject.user.clientData = ""
                        this.$store.dispatch('addDevice', this.deviceObject).then(
                            response => {
                                this.reload();
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    }
                    this.dialog = false;
                }
            },
            editItem(item) {
                this.editedIndex = this.devices.indexOf(item);
                this.device = Object.assign({}, item);
                this.dialog = true;
            },
            selectedItem(item) {
                this.singleSelect = false
                this.editedIndex = this.devices.indexOf(item);
                for (let i = 0; i < this.devices.length; i++) {
                    this.devices[i].selected = false
                }
                this.devices[this.editedIndex].selected = true
                this.device = this.devices[this.editedIndex]
                this.singleSelect = true
                let currentDate = new Date();
                  let year = currentDate.getFullYear();
                  let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                  let day = String(currentDate.getDate()).padStart(2, '0');

                  this.device.start = `${year}-${month}-${day}`;
                  this.device.startTime = {HH:'00',mm:'00'};

                  this.device.end = `${year}-${month}-${day}`;
                  this.device.endTime = {HH:'23',mm:'50'};

            },


            sendDeviceAction() {
              if (this.device.lastAction == 'Bloquear' || this.device.lastAction == '') {
                this.$store.dispatch('sendDeviceActionTraccar', {
                      "deviceId": this.device.idTraccar,
                      "description": "version",
                      "type": "custom",
                      "attributes": {
                        "data": "Relay,0#"
                      }
                    }
                ).then(response => {
                  this.device.lastAction = 'Desbloquear'
                  this.saveData()
                  this.dialogBlock = false
                })
              } else {
                this.$store.dispatch('sendDeviceActionTraccar', {
                  "deviceId": this.device.idTraccar,
                  "description": "version",
                  "type": "custom",
                  "attributes": {
                    "data": "Relay,1#"
                  }
                }).then(response => {
                  this.device.lastAction = 'Bloquear'
                  this.saveData()
                  this.dialogBlock = false
                })
              }
            },
            deleteItem(item) {
                this.editedIndex = this.devices.indexOf(item);
                this.device = Object.assign({}, item);
                confirm('Está seguro de que quiere eliminar el registro?') &&
                this.$store.dispatch('deleteDevice', this.device.id).then(response => {
                    this.reload()
                })
            },
            reload() {
                let search = ""
                if (this.$store.state.deviceUser == '' || this.$store.state.deviceUser == null) {
                    search = this.$store.state.idUser
                } else {
                    search = this.$store.state.deviceUser.login
                }

              this.$store.dispatch('getRelatedDevicesByUserLoginFull', search).then(responseRelated => {
                this.devices = []
                this.geoFences = []
                for (let i = 0; i < responseRelated.data.length; i++) {
                  let object = JSON.parse(responseRelated.data[i].value)
                  object.id = responseRelated.data[i].id
                  object.selected = false
                  object.user = responseRelated.data[i].user
                  if(!this.$store.getters.isActiveDevice(object)){
                    continue
                  }
                  this.devices.push(object)
                }
                this.devices.sort((a, b) => (a.userName > b.userName) ? 1 : -1)
              })

              if (search === 'grupooro357') {
                  try {
                      this.$store.dispatch('getOneUser', search).then(responseData => {
                          if (responseData.data.clientData != null) {
                              let clientData = JSON.parse(responseData.data.clientData)
                              if (clientData.userChildren && clientData.userChildren.length > 0) {
                                  for (let j = 0; j < clientData.userChildren.length; j++) {
                                      if (clientData.userChildren[j] != null && clientData.userChildren[j].login != null) {
                                          this.$store.dispatch('getOneUser', clientData.userChildren[j].login).then(responseDevices => {
                                              if (responseDevices.data.clientData) {
                                                  let clientDataForDevices = JSON.parse(responseDevices.data.clientData);
                                                  for (let z = 0; z < clientDataForDevices.devices.length; z++) {
                                                      this.devices.push(clientDataForDevices.devices[z]);
                                                  }
                                              }
                                          })
                                      }
                                  }

                              }

                          }

                      })
                  } catch (e) {
                    //ERROR TO PROCESS
                  }
                  ;
              }

            },
            mark(event) {
                this.geoFence.position = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng(),
                }
            },
          async getReport() {
            this.$store.state.progress = true;
            var reportList = [];
            let distanceAux = 0;
            for (let i = 0; i < this.listReportTracking.length; i++) {
              var track = new Object();
              track.IDENTIFICADOR = this.device.id
              track.IMEI = this.device.imei.toString()
              track.ULTIMA_ACCION = this.device.lastAction
              track.CLIENTE_LOGIN = this.device.login
              track.CLIENTE_NOMBRE = this.device.name
              track.MODELO = this.device.model
              track.ESTADO_MOTOR = this.listReportTracking[i].accStatus=='1'?'PRENDIDO':'APAGADO';
              track.DIRECCION = this.listReportTracking[i].direction;
              track.HORA = this.formatDateMinus(this.listReportTracking[i].gpsTime);
              track.LATITUD = this.listReportTracking[i].lat;
              track.LONGITUD = this.listReportTracking[i].lng;
              track.VELOCIDAD = this.listReportTracking[i].accStatus=='1'? (this.listReportTracking[i].speed*1.852):0;
              distanceAux = distanceAux + parseInt(this.listReportTracking [i].attributes.distance)
              track.DISTANCIA_RECORRIDA =  (distanceAux/1000).toFixed(2)

              reportList.push(track);
            }
            if (reportList.length == 0) {
              alert('No existen registros.');
            }
            this.$store.state.progress = false;
            return reportList;
          },

          async getReportStops() {
            this.$store.state.progress = true;
            var reportList = [];
            for (let i = 0; i < this.markerStops.length; i++) {
              var track = new Object();
              track.IDENTIFICADOR = this.device.id
              track.IMEI = this.device.imei.toString()
              track.ULTIMA_ACCION = this.device.lastAction
              track.CLIENTE_LOGIN = this.device.login
              track.CLIENTE_NOMBRE = this.device.name


              track.HORA_INICIO = this.formatDateMinus(this.markerStops[i].data.startTime)
              track.HORA_FIN = this.formatDateMinus(this.markerStops[i].data.endTime)
              track.HORA_DURACION = this.$store.getters.msToTime(this.markerStops[i].data.duration)
              track.LATITUD = this.markerStops[i].data.latitude
              track.LONGITUD = this.markerStops[i].data.longitude
              reportList.push(track);
            }
            if (reportList.length == 0) {
              alert('No existen registros.');
            }
            this.$store.state.progress = false;
            return reportList;
          },
        },
        computed: {},
        created() {
            this.reload()
        },

    };
</script>

<style scoped>
    .circle {
        padding-top: 12px;
        width: 70px;
        height: 70px;
        background: #4e474c;
        -moz-border-radius: 50px;
        -webkit-border-radius: 50px;
        border-radius: 50px;
    }
    .buttonBorder{
        border: none;
        outline:none;
    }
    .iconClicked{
        width:40px;
    }
    .icon{
        width:40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceReport.vue